export default __webpack_public_path__ + "025e700e7b53edfb3972867bf8638713.png";